<template lang="pug">
div.qwe( @click="addImg" )
  input( type="file" accept="image/jpeg,image/png" style="display: none" ref="fileInput" multiple @change="uploadFile" )
  div.img-container( :class="{'container-height' : !imgUrl}" @click="$refs.fileInput.click()" )
    div.img-header
      div.corner-badge
        span.text-12 {{ deadline }}
    div( v-if="!imgUrl" )
      span.app-btn-action.mb-8  Добавить изображение
    div.loaded-img( v-else )
      img.img( :src="imgUrl" )
  div.price
    span.text-12 Цель:
    span.text-16-b {{ returnPrice }} {{convertToValueLabel('RUR')}}
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: "GoalVisualization",
  props: {
    value: null,
    deadline: null,
    imgUrl: null,
  },

  computed: {
    ...mapState('goals', ['selectedGoal']),

    returnPrice() {
      return this.value ? this.value.toLocaleString("ru-RU").replace(/\s/g, ",") : 0 
    }
  },

  methods: {
    ...mapActions('goals', ['deleteAttachment', 'sendNewAttachment']),

    addImg() {
      this.$emit('addImg')
    },

    deletePhoto() {
      let obj = {goalsUuid: this.selectedGoal.uuid, state: 1}
      return this.deleteAttachment(obj)
    },

    uploadFile(event) {
      let file = event.target.files[0]
      if(!file) return
      this.deletePhoto().then(() => {
        let formData = new FormData()
        formData.append("state", 1)
        formData.append("file", file)
        formData.append("_file", file.name)
        let obj = {goalsUuid: this.selectedGoal.uuid, photo: formData}
        this.sendNewAttachment(obj).then(() => {
          this.$emit('loadPhoto')
        })
      })
    }
  }
};

</script>
<style scoped>
.container-height {
  height: 336px !important;
}
.loaded-img {
  height: 100%;
  width: 100%;
}
.img {
  height: 100%;
  width: 100%;
}
.qwe {
  border-radius: 6px;
  border-width: 1px;
  border: 1px solid #D4D4D4
}
.img-container {
  position: relative;
  background: #E5E7EB;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.price {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 12px;
}
.corner-badge {
  padding: 4px;
  position: absolute;
  top: 8px;
  left: 8px;
  background: grey;
  color: #000000;
  font-size: 12px;
  border-radius: 6px;
  border-top-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.delete-photo {
  padding: 4px;
  position: absolute;
  width: 10%;
  right: 8px;
  top: 8px
}
</style>
